import { useEffect } from "react";

export default function useTheme(theme) {
  useEffect(() => {
    const body = document.body;
    body.classList.remove("theme-anthem", "theme-fc");
    if (theme === "anthem") body.classList.add("theme-anthem");
    else body.classList.add("theme-fc");
    return () => {
      body.classList.remove("theme-anthem", "theme-fc");
    };
  }, [theme]);
}
